export default [
  {
    path: '/app/portal/tramite-orientacion',
    name: 'rt-web-tramite',
    component: () => import('@/views/erp/portal/tramite_orientacion/TramiteList.vue'),
    meta: {
      resource: 'rt-web-tramite',
      pageTitle: 'Tramite Orientación',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Tramite Orientación',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/portal/diseno',
    name: 'rt-web-headers',
    component: () => import('@/views/erp/portal/diseno/Diseno.vue'),
    meta: {
      resource: 'rt-web-headers',
      pageTitle: 'Diseño',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Diseño',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/portal/info-general',
    name: 'rt-web-info',
    component: () => import('@/views/erp/portal/general/General.vue'),
    meta: {
      resource: 'rt-web-info',
      pageTitle: 'Info General',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Info General',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/portal/directorio',
    name: 'rt-web-directory',
    component: () => import('@/views/erp/portal/directorio/DirectorioList.vue'),
    meta: {
      resource: 'rt-web-directory',
      pageTitle: 'Directorio',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Directorio',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/portal/registros-frm-contacto',
    name: 'rt-web-contacto',
    component: () => import('@/views/erp/portal/frm_contacto/FrmContactoList.vue'),
    meta: {
      resource: 'rt-web-contacto',
      pageTitle: 'Registros Frm. Contacto',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Registros Frm. Contacto',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/portal/registros-frm-libro-reclamacion',
    name: 'rt-web-libro',
    component: () => import('@/views/erp/portal/frm_libro/FrmLibroList.vue'),
    meta: {
      resource: 'rt-web-libro',
      pageTitle: 'Registros Libro Reclamaciones',
      breadcrumb: [
        {
          text: 'Portal',
        },
        {
          text: 'Registros Libro Reclamaciones',
          active: true,
        },
      ],
    },
  },
]
